<div class="side-panel-section">
    <div class="mt-2 mb-2">
      <div class="field-input-group field-search input-group">
        <input class="form-control field-input"  placeholder="Search Workflows"
            [(ngModel)]="searchInput" (ngModelChange)="searchMatchResults()">
        <div class="field-input-group-actions">
            <button ycnTooltip class="btn btn-transparent" [ngClass]="{ 'btn-clear': isSearching }" 
                [tooltipTitle]="isSearching ? 'Clear the field' : ''" (click)="clearSearch()">
                <svg ycnIcon [name]="searchIcon" [class]="searchIcon"></svg>
            </button>
        </div>
      </div>
    </div>
</div>
<div class="side-panel-section">
    @if (isSearching) {
        @for (result of searchResults; track $index) {
            <div class="mb-row search-result">
                <div class="d-flex align-items-center text-gray-30 pb-4px">
                    <svg ycnIcon name="icon-search" class="icon-search fill-current text-gray-40 flex-none mr-1"></svg>
                    <a (click)="searchResultsClickHandler(result.subcategoryId)" [innerHTML]="result.matchHTML" href="javascript:void(0);"></a>
                </div>
                <div class="ml-3 text-smallest text-gray-50" [innerHTML]="result.locationHTML"></div>
            </div>
        }
        @if (searchResults.length === 0) {
            <div>No results found</div>
        }
    }
    @else if (categories && selectedSteps.length === 0) {
        <ycn-guided-workflows-categories
            [expandableCategories]="expandableCategories" 
            [(steps)]="selectedSteps"
            [(selectedCategory)]="selectedCategory"
            (selectedSubcategory)="setSelectedSubcategory($event)"></ycn-guided-workflows-categories>
    } @else {
        <ycn-guided-workflows-steps 
            [categoryTitle]="selectedCategory?.title || ''"
            [subcategory]="selectedSubcategory"
            [steps]="selectedSteps"></ycn-guided-workflows-steps>
    }
</div>
